module.exports = __webpack_public_path__ + "img/box_pro_one_6.cbd0e0dc.jpg";